import { withAuth } from '@/components/auth-wrapper';
import Layout from '@/components/layouts/page-layout';

export default withAuth(Layout);
